import zod from "zod";
import { z } from "/@/modules/zodUtils";

export const csvPersonalInfo = [
  "name",
  "nameKana",
  "special",
  "birthday",
  "email",
  "phoneNumber",
  "postcode",
  "address",
  "registrationNumber",
] as const;
export const CsvPersonalInfoScheme = z.enum(csvPersonalInfo);
export type CsvPersonalInfo = zod.infer<typeof CsvPersonalInfoScheme>;

const csvAffiliationInfo = [
  "affiliation",
  "affiliationPhoneNumber",
  "affiliationAddress",
] as const;
export const CsvAffiliationInfoScheme = z.enum(csvAffiliationInfo);
export type CsvAffiliationInfo = zod.infer<typeof CsvAffiliationInfoScheme>;

const csvAssociationInfo = [
  "branchs",
  "branch_positions",
  "branch_labels",
  "committees",
  "committee_positions",
  "committee_labels",
  "confirmed_at",
  "unsubscribed_at",
] as const;
export const CsvAssociationInfoScheme = z.enum(csvAssociationInfo);
export type CsvAssociationInfo = zod.infer<typeof CsvAssociationInfoScheme>;

function csvInfoTranslater(v) {
  switch (v) {
    case "name":
      return "名前";
    case "nameKana":
      return "ふりがな";
    case "special":
      return "正会員/特別会員";
    case "birthday":
      return "生年月日";
    case "email":
      return "メールアドレス";
    case "phoneNumber":
      return "電話番号";
    case "postcode":
      return "郵便番号";
    case "address":
      return "住所";
    case "registrationNumber":
      return "登録番号";
    case "affiliation":
      return "所属事業所";
    case "affiliationPhoneNumber":
      return "所属事業所電話番号";
    case "affiliationAddress":
      return "所属事業所住所";
    case "branchs":
      return "所属支部";
    case "branch_positions":
      return "所属支部の役職";
    case "branch_labels":
      return "所属支部の権限";
    case "committees":
      return "所属委員会";
    case "committee_positions":
      return "所属委員会の役職";
    case "committee_labels":
      return "所属委員会の権限";
    case "confirmed_at":
      return "登録日";
    case "unsubscribed_at":
      return "退会日";
  }
}

export const CsvInfoScheme = z.union([
  CsvPersonalInfoScheme,
  CsvAffiliationInfoScheme,
  CsvAssociationInfoScheme,
]);
export type CsvInfo = zod.infer<typeof CsvInfoScheme>;
export type CsvInfoOption = {
  value: CsvInfo;
  label: string;
};

export const csvInfoOptions: CsvInfoOption[] = [
  ...csvPersonalInfo,
  ...csvAffiliationInfo,
  ...csvAssociationInfo,
].map((v) => ({
  value: v,
  label: csvInfoTranslater(v),
}));
